module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('a', {
    attrs: {
      "id": "title90"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_vm._v("Special thanks to "), _c('br'), _vm._v("Tom Valesky (again) and "), _c('br'), _vm._v("Gerald Molnar for their "), _c('br'), _vm._v("marksmen’s eyes for "), _c('br'), _vm._v("weapons errors.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a71b859","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429967365_ack01.vue
// module id = 72
// module chunks = 0